import styles from './OfferCard.module.css';

export const OffersHeading = ({
    title,
    subtitle
}: {
    title: string;
    subtitle: string;
}) => {
    return (
        <div className={styles.separator}>
            <h2 className={styles.separatorTitle}>{title}</h2>
            <p className={styles.separatorSubtitle}>{subtitle}</p>
        </div>
    );
};
